import _objectSpread from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { isSome as e } from "../core/maybe.js";
import { urlToObject as t } from "../core/urlUtils.js";
import { getScale as i } from "../geometry/support/scaleUtils.js";
import { getLayerFloorFilterClause as n, combineFloorsDefinitionExpression as r } from "../views/support/floorFilterUtils.js";

function s(e, t) {
  return t ? _objectSpread(_objectSpread({}, t), {}, {
    query: _objectSpread(_objectSpread({}, e), t.query)
  }) : {
    query: e
  };
}

function o(e) {
  return "string" == typeof e ? t(e) : e;
}

function l(e, t, i) {
  var n = {};

  for (var _r in e) {
    if ("declaredClass" === _r) continue;
    var _s = e[_r];
    if (null != _s && "function" != typeof _s) if (Array.isArray(_s)) {
      n[_r] = [];

      for (var _e = 0; _e < _s.length; _e++) {
        n[_r][_e] = l(_s[_e]);
      }
    } else if ("object" == typeof _s) {
      if (_s.toJSON) {
        var _e2 = _s.toJSON(i && i[_r]);

        n[_r] = t ? _e2 : JSON.stringify(_e2);
      } else n[_r] = t ? _s : JSON.stringify(_s);
    } else n[_r] = _s;
  }

  return n;
}

function f(_ref) {
  var e = _ref.mapExtent,
      t = _ref.floors,
      r = _ref.width,
      s = _ref.sublayers,
      o = _ref.layerIds;
  var l = {},
      f = {
    extent: e,
    width: r,
    spatialReference: null == e ? void 0 : e.spatialReference
  };
  var c = s;
  o && o.length && s && (c = s.filter(function (e) {
    return o.includes(e.id);
  }));

  var u = i(f),
      y = [],
      p = function p(e) {
    var t = 0 === u,
        i = 0 === e.minScale || u <= e.minScale,
        n = 0 === e.maxScale || u >= e.maxScale;
    e.visible && (t || i && n) && (e.sublayers ? e.sublayers.forEach(p) : y.unshift(e));
  };

  if (c && c.forEach(p), c && c.length) {
    var _e3 = y.map(function (e) {
      var i = n(t, e);
      return e.toExportImageJSON(i);
    }),
        _i = _e3.some(function (e) {
      return "mapLayer" === e.source.type ? e.source.mapLayerId !== e.id : "dataLayer" === e.source.type;
    });

    if (_i) {
      var _t = JSON.stringify(_e3);

      "[]" === _t && (_t = "[{}]"), l.dynamicLayers = _t;
    } else if (!_i) {
      if (o && o.length) l.layerIds = o;else {
        var _e5 = c.map(function (_ref2) {
          var e = _ref2.id;
          return e;
        });

        _e5.length && (l.layerIds = _e5);
      }

      var _e4 = a({
        floors: t,
        visibleSublayers: y
      });

      if (_e4 && _e4.length) {
        var _t2 = _e4.reduce(function (e, t) {
          return t.definitionExpression && (e[t.id] = t.definitionExpression), e;
        }, {});

        Object.keys(_t2).length && (l.layerDefs = JSON.stringify(_t2));
      }
    }
  }

  return l;
}

function a(_ref3) {
  var t = _ref3.floors,
      i = _ref3.visibleSublayers;
  var s = !(null == t || !t.length),
      o = i.filter(function (e) {
    return null != e.definitionExpression || s && null != e.floorInfo;
  });
  if (!o.length) return null;
  return o.map(function (i) {
    var s = n(t, i),
        o = e(s) ? r(s, i) : i.definitionExpression,
        l = {
      id: i.id,
      definitionExpression: null
    };
    return o && (l.definitionExpression = o), l;
  });
}

export { s as asValidOptions, l as encode, o as parseUrl, f as toDynamicLayersJSON };